import api from '../../api/settings'
import toastr from 'toastr'
import { LogError } from '@/util/responseHandler'
import { notification } from '@/util/notification'

export default {

    async all({commit}){
        try {
            commit('loading',null,{root:true})
            const res = await api.all()
            if(res && res.status==200){
                commit('settings',res.data.data)
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
            return res
        } catch (error) {
            LogError(commit,error,'loaded')
        }
    },

    async getSetting({commit},column){
        try {
            commit('loading',null,{root:true})
            const res = await api.setting(column)
            if(res && res.status==200){
                //console.log('set',res.data.data)
                commit('setting',res.data.data)
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
        } catch (error) {
            LogError(commit,error,'loaded')
        }
    },

    async update({commit},data){
        var res;
        try {
            commit('submitting',null,{root:true})
            res = await api.update(data)
            if(res.status==200){
                if(data.show_front_page_message !== undefined){ 
                    data.show_front_page_message 
                    ? notification.success("Front Page Notification Enabled")
                    : notification.success("Front Page Notification Disabled")
                }else{
                    notification.success("data updated successfully")
                }
            }else{
                toastr.warning(res.data.message)
            }
            commit('submitted',null,{root:true})
            return res
        } catch (err) {
            LogError(commit,err,'submitted')
        }
    },

    async updateReferralBonus({commit},{id,data}){
        var res;
        try {
            commit('submitting',null,{root:true})
            res = await api.updateReferralBonus(id,data)
            if(res.status==200){
                notification.success("Setting updated successfully")
            }else{
                toastr.warning(res.data.message)
            }
            commit('submitted',null,{root:true})
            return res;
        } catch (err) {
            LogError(commit,err,'submitted')
        }
    },

    async getReferralBonusSetting({commit}){
        var res;
        try {
            commit('loading',null,{root:true})
            res = await api.referralBonusSettings()
            if(res.status==200){
                commit('referralBonusSetting',res.data.data)
                //notification.success("Setting updated successfully")
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
            return res;
        } catch (err) {
            LogError(commit,err,'loaded')
        }
    },

    async updateUpgradeBonus({commit},{id,data}){
        var res;
        try {
            commit('submitting',null,{root:true})
            res = await api.updateUpgradeBonus(id,data)
            if(res.status==200){
                notification.success("Setting updated successfully")
            }else{
                toastr.warning(res.data.message)
            }
            commit('submitted',null,{root:true})
            return res;
        } catch (err) {
            LogError(commit,err,'submitted')
        }
    },

    async getUpgradeBonusSetting({commit}){
        var res;
        try {
            commit('loading',null,{root:true})
            res = await api.upgradeBonusSettings()
            if(res.status==200){
                commit('upgradeBonusSetting',res.data.data)
                //notification.success("Setting updated successfully")
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
            return res;
        } catch (err) {
            LogError(commit,err,'loaded')
        }
    },

    async updateUnilevelBonus({commit},{id,data}){
        var res;
        try {
            commit('submitting',null,{root:true})
            res = await api.updateUnilevelBonus(id,data)
            if(res.status==200){
                notification.success("Setting updated successfully")
            }else{
                toastr.warning(res.data.message)
            }
            commit('submitted',null,{root:true})
            return res;
        } catch (err) {
            LogError(commit,err,'submitted')
        }
    },

    async getUnilevelBonusSetting({commit}){
        var res;
        try {
            commit('loading',null,{root:true})
            res = await api.unilevelBonusSettings()
            if(res.status==200){
                commit('unilevelBonusSetting',res.data.data)
                //notification.success("Setting updated successfully")
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
            return res;
        } catch (err) {
            LogError(commit,err,'loaded')
        }
    },

    async getStockistUplineBonusSetting({commit}){
        var res;
        try {
            commit('loading',null,{root:true})
            res = await api.stockistUplineBonusSettings()
            if(res.status==200){
                commit('stockistUplineBonusSetting',res.data.data)
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
            return res;
        } catch (err) {
            LogError(commit,err,'loaded')
        }
    },

    async updateStockistUplineBonusSetting({commit},{id,data}){
        var res;
        try {
            commit('submitting',null,{root:true})
            res = await api.updateStockistUplineBonusSettings(id,data)
            if(res.status==200){
                notification.success("Setting updated successfully")
            }else{
                toastr.warning(res.data.message)
            }
            commit('submitted',null,{root:true})
            return res;
        } catch (err) {
            LogError(commit,err,'submitted')
        }
    },

    async getCurrencyConfig({commit},{id,currency}){
        try {
            commit('loading',null,{root:true})
            const res = await api.currencyConfig(id,currency)
            if(res && res.status==200){
                //console.log(res.data.data.data)
                //commit('productCurrencyConfig',res.data.data)
            }else{
                toastr.warning(res.data.message)
            }
            commit('loaded',null,{root:true})
            return res
        } catch (error) {
            LogError(commit,error,'loaded')
        }
    },

    async updateCurrencyConfig({commit},{id,data}){
        try {
            commit('submitting',null,{root:true})
            const res = await api.updateCurrencyConfig(id,data)
            if(res && res.status==200){
                //console.log(res.data.data.data)
                //commit('packageCurrency',res.data.data)
                toastr.success(res.data.message)
            }else{
                toastr.warning(res.data.message)
            }
            commit('submitted',null,{root:true})
            return res
        } catch (error) {
            LogError(commit,error,'submitted')
        }
    },
}